// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"261":"60e7fbc5","348":"1788d0e5","405":"5f789f37","566":"9cf74d43","610":"af7a16a4","656":"496d31cb","681":"2ad4b445","702":"a85d6cbc","721":"07fcabd2","852":"e6f69d40","938":"161db271","954":"54299c2d"}[chunkId] + ".chunk.js";
};